import { createUseMutationHook } from './createUseMutationHook';

export const usePersonAnalyticsDataUpdate = createUseMutationHook('person_analytics_data_update',
    () => [
        'get_person_details',
    ],
);
